import { strToObj } from 'src/helpers/globals'

// HTML Class generator for sticky elements
export function stickyClasses (anchor, defaultClasses = null) {
  if (!anchor) {
    return {}
  }

  const vars = getAnchorVars(anchor)
  return {
    [vars.className]: !!vars.className,
    'sticky-position': !!defaultClasses,
    ...strToObj(defaultClasses)
  }
}

// Validation function for ensuring the anchor is any of the following
export function stickyValidator (value) {
  return ['none', 'dialog', 'dialog-menubar', 'page', 'page-menubar', 'statusbar'].includes(value)
}

// Manually insert a css offset based on an element's main anchor position
export function manualStickyOffset (anchor, value = '0px', operator = '+') {
  if (!anchor || !value) {
    return undefined
  }
  const vars = getAnchorVars(anchor)
  return `calc(${vars.css ? `var(${vars.css})` : '0px'} ${operator} ${value})`
}

function getAnchorVars (anchor) {
  switch (anchor) {
    case 'page': {
      return {
        css: '--sticky-from-page',
        className: 'from-page'
      }
    }
    case 'page-menubar': {
      return {
        css: '--sticky-from-page-menubar',
        className: 'from-page-menubar'
      }
    }
    case 'dialog': {
      return {
        css: '--sticky-from-toolbar',
        className: 'from-toolbar'
      }
    }
    case 'dialog-header': {
      return {
        css: '--sticky-from-toolbar-header',
        className: 'from-toolbar-header'
      }
    }
    case 'dialog-menubar': {
      return {
        css: '--sticky-from-toolbar-menubar',
        className: 'from-toolbar-menubar'
      }
    }
    case 'dialog-menubar-header': {
      return {
        css: '--sticky-from-toolbar-menubar-header',
        className: 'from-toolbar-menubar-header'
      }
    }
    case 'statusbar': {
      return {
        css: '--safe-area-inset-top',
        className: 'from-statusbar'
      }
    }
    default: {
      return {
        css: null,
        className: null
      }
    }
  }
}
